import { useQuery } from '@tanstack/react-query';
import { fetchActiveIecMaterialTypes } from '../../../api/administration/iecMaterialTypes';

export const useActiveIecMaterialTypes = (options = {}) => {
  const query = useQuery({
    queryKey: ['iecMaterialTypes', 'active'],
    queryFn: () => fetchActiveIecMaterialTypes(),
    enabled: options.enabled !== false,
  });

  return {
    ...query,
    iecMaterialTypes: query.data?.data?.iecMaterialTypes ?? [],
  };
};

export default useActiveIecMaterialTypes;
